<template lang="pug">
.study-navigation
  //- 情報表示
  .study-navigation__info
    .study-navigation__info__title.text-large.font-bold {{ studyTitle }}
    .study-navigation__info__time.font-bold
      .study-navigation__info__time__label
        slot(name='currentTimeLabel')
      .study-navigation__info__time__value {{ currentTime }}
    .study-navigation__info__time.font-bold
      .study-navigation__info__time__label
        slot(name='remainingTimeLabel')
      .study-navigation__info__time__value {{ remainingTime }}
  //- 操作部分
  .study-navigation__control
    button-direction.study-navigation__control__button-direction(
      v-if='showLeftButton',
      direction='left',
      @click='leftButtonEvent'
    )
    button-direction.study-navigation__control__button-direction(
      v-if='showRightButton',
      direction='right',
      @click='rightButtonEvent'
    )
    button-menu.study-navigation__control__button-menu(v-if='showMenuButton', @click='menuButtonEvent')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonDirection from '@/components/molecules/student/ButtonDirection.vue'
import ButtonMenu from '@/components/molecules/student/ButtonMenu.vue'

/**
 * 学習画面ナビゲーション部
 */
@Component({
  components: {
    ButtonDirection,
    ButtonMenu,
  },
})
export default class StudyNavigation extends Vue {
  // 学習タイトル
  @Prop()
  studyTitle!: string

  // 実施時間
  @Prop()
  currentTime!: string

  // 残り時間
  @Prop()
  remainingTime!: string

  // 縦書きフラグ
  @Prop({ default: false })
  isVertical?: boolean

  // 次へボタン表示フラグ
  @Prop({ default: true })
  showNextButton?: boolean

  // 前へボタン表示フラグ
  @Prop({ default: true })
  showPrevButton?: boolean

  // メニューボタン表示フラグ
  @Prop({ default: true })
  showMenuButton?: boolean

  // 次へボタン押下時イベント
  @Prop()
  nextButtonEvent?: Function

  // 前へボタン押下時イベント
  @Prop()
  prevButtonEvent?: Function

  // メニューボタン押下時イベント
  @Prop()
  menuButtonEvent?: Function

  /**
   * 左右ボタンの表示フラグとイベントを指定
   * 横書き：左ボタンが前へ、右ボタンが次へ
   * 縦書き：右ボタンが前へ、左ボタンが次へ
   */
  private get showLeftButton() {
    return this.isVertical ? this.showNextButton : this.showPrevButton
  }

  private get showRightButton() {
    return this.isVertical ? this.showPrevButton : this.showNextButton
  }

  private get leftButtonEvent() {
    return this.isVertical ? this.nextButtonEvent : this.prevButtonEvent
  }

  private get rightButtonEvent() {
    return this.isVertical ? this.prevButtonEvent : this.nextButtonEvent
  }
}
</script>

<style lang="stylus" scoped>
.study-navigation
  display flex
  align-items center
  justify-content space-between
  padding 5px 0
  &__info
    display flex
    align-items center
    &__title
      color var(--color-study-navigation-title__text)
    &__time
      display flex
      margin-left 20px
  &__control
    display flex
    align-items center
    &__button-direction
      margin-right 20px
</style>
